<!--
 * @Author: LHB
 * @Date: 2022-06-12 21:03:30
 * @LastEditTime: 2022-06-14 22:20:12
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\components\confirmModal.vue
 * ---
-->
<template>
  <div class="wrap">
    <van-popup
      v-model="isShow"
      round
      :position="position"
      @click-overlay="cancle"
    >
      <div class="content">
        <div class="tilte-box">
          <div class="main-title" v-bind:style="cutomClass" v-if="mainTitle">
            {{ mainTitle }}
          </div>
          <div class="sub-title" v-if="subTitle">{{ subTitle }}</div>
        </div>
        <div class="button-box">
          <div class="button button-cancle" @click="cancle">
            {{ cancleText }}
          </div>
          <div class="button button-confirm" @click="confirm">
            {{ confirmText }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    isShowpop: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'center'
    },
    mainTitle: {
      type: String,
      default: '确定退出当前账号吗?'
    },
    subTitle: {
      type: String,
      default: ''
    },
    cancleText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    cutomClass: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  created() {
    this.isShow = this.isShowpop
  },
  computed: {
    // isShow: () => {
    //   console.log('isShow===', this.isShowpop)
    //   return this.isShowpop
    // }
  },
  mounted() {},
  methods: {
    cancle() {
      console.log('取消')
      this.$emit('cancle')
    },
    confirm() {
      console.log('qeuidng')
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.wrap {
  width: 100%;
  min-height: 100vh;
}
.content {
  width: 560px;
  min-height: 288px;
  background: #ffffff;
  border-radius: 32px;
  padding: 72px 34px 48px 34px;
  box-sizing: border-box;
}
.tilte-box {
  width: 100%;
}
.main-title {
  font-size: 34px;
  font-weight: bold;
  color: #323233;
  line-height: 48px;
  text-align: center;
}
.sub-title {
}
.button-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 48px;
}
.button {
  width: 230px;
  height: 72px;
  text-align: center;
  line-height: 72px;
  border-radius: 40px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.button-cancle {
  background: #ebedf0;
  color: #969799;
}
.button-confirm {
  background: #ee0a24;
  color: #ffffff;
}
</style>
